<script setup lang="ts">
useHead({
  bodyAttrs: {
    class: 'app'
  }
})
</script>

<template>
  <nuxt />
</template>

<style lang="scss">
@import '~/assets/app/scss/index';
</style>
